import React, { useState, useEffect, useCallback } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { axiosInstance } from '@appblocks/frontend/client/utils';


const moment = require('moment');

const TIME_RANGES = [
    {
        label: 'Last 1 hour',
        value: 60 * 1,
    },
    {
        label: 'Last 6 hours',
        value: 60 * 6,
    },
    {
        label: 'Last 12 hours',
        value: 60 * 12,
    },
    {
        label: 'Last 24 hours',
        value: 60 * 24,
    },
    {
        label: 'Last 3 days',
        value: 60 * 24 * 3,
    },
    {
        label: 'Last 7 days',
        value: 60 * 24 * 7,
    },
    {
        label: 'Custom Range',
        value: 0,
    },
];

export default function EventView(props) {
    const [startTime, setStartTime] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());
    const [currentRange, setCurrentRange] = useState(60);
    const [timeRange, setTimeRange] = useState([moment().subtract(1, 'hours').toDate(), new Date()]);

    useEffect(() => {
        if (currentRange.toString() === '0') {
            // custom range
            setTimeRange([startTime, endTime]);
        }
    }, [startTime]);

    useEffect(() => {
        if (currentRange.toString() === '0') {
            // custom range
            setTimeRange([startTime, endTime]);
        }
    }, [endTime]);

    // useEffect(() => {
    //     let tmpStartTime = moment();
    //     if (currentRange.toString() === '0') {
    //         // custom range
    //         tmpStartTime = moment().subtract(1, 'days');
    //     } else {
    //         tmpStartTime = moment().subtract(currentRange, 'minutes');
    //     }
    //     setStartTime(tmpStartTime.toDate());
    // }, [currentRange]);

    useEffect(() => {
        if (props.onTimeRangeChanged) {
            if (currentRange.toString() === '0') {
                // custom range
                props.onTimeRangeChanged({
                    startTime,
                    endTime,
                    range: currentRange,
                });
            } else {
                const tmpEndTime = new Date();
                const tmpStartTime = moment(tmpEndTime).subtract(currentRange, 'minutes').toDate();
                props.onTimeRangeChanged({
                    startTime: tmpStartTime,
                    endTime: tmpEndTime,
                    range: currentRange,
                });
                setStartTime(tmpStartTime);
                setEndTime(tmpEndTime);
            }
        }
    }, [currentRange, timeRange]);

    return (
        <div className="row">
            <div className={`col-md-4 ${currentRange.toString() !== '0' && 'offset-md-8'}`}>
                <select
                    className="form-select"
                    value={currentRange}
                    onChange={e => setCurrentRange(e.target.value)}
                >
                    {TIME_RANGES.map((range, index) => (
                        <option key={index} value={range.value}>
                            {range.label}
                        </option>
                    ))}
                </select>
            </div>
            {currentRange.toString() === '0' && (
                <>
                    <Form.Group className="col-md-4">
                        {/* <Form.Label>Start Time</Form.Label> */}
                        <Form.Control
                            type="datetime-local"
                            value={moment(startTime).format('YYYY-MM-DDTHH:mm')}
                            disabled={currentRange.toString() !== '0'}
                            onChange={(e) => {
                                setStartTime(moment(e.target.value).toDate());
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="col-md-4">
                        {/* <Form.Label>End Time</Form.Label> */}
                        <Form.Control
                            type="datetime-local"
                            value={moment(endTime).format('YYYY-MM-DDTHH:mm')}
                            disabled={currentRange.toString() !== '0'}
                            onChange={(e) => {
                                setEndTime(moment(e.target.value).toDate());
                            }}
                        />
                    </Form.Group>
                </>
            )}

        </div>
    );
}
